module.exports = __webpack_public_path__ + "static/media/BANNER-SUSCRIPCIONES.622ad9d6.jpg";